import { Header } from '@mairistem/composants';

const HeaderLink = (p) => <Header as="a" {...p} />;

export default HeaderLink;
